import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';

import MuiGrid from '@material-ui/core/Grid';

import ViewWrapper from 'views/ViewWrapper';
import TableReleasePlatformFees from 'components/TableReleasePlatformFees';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
    textTransform: 'capitalize',
  },
  actionRow: {
    paddingBottom: theme.spacing(1),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
});

const PlatformFees = ({ ...props }) => {
  const { classes, match } = props;
  const {
    params: { parentEntity },
  } = match;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            {parentEntity} Platform Fees
          </MuiTypography>
          {parentEntity === 'release' && <TableReleasePlatformFees />}
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(PlatformFees);
